export class CmpFauxSelectOptionObject {
    constructor(
        public name = '',
        public miniText = '',
        public miniText2 = '',
        public value = '',
        public disabled = false,
        public miniTextClass = '',
        public abbreviation = ''
    ) { }
}
